"use client";

import { usePathname } from 'next/navigation';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function LayoutContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // فحص المسار: إذا كان الرابط يبدأ بـ /admin أو /login لا تظهر الهيدر والفوتر
  const isDashboard = pathname?.startsWith('/admin') || pathname?.startsWith('/login');

  return (
    <>
      {!isDashboard && <Header data-component-id="src/app/LayoutContent.tsx:15:23" data-component-path="src/app/LayoutContent.tsx" data-component-line="15" data-component-end-line="15" data-component-file="LayoutContent.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />}
      <main data-component-id="src/app/LayoutContent.tsx:16:6" data-component-path="src/app/LayoutContent.tsx" data-component-line="16" data-component-end-line="18" data-component-file="LayoutContent.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%7D" className={!isDashboard ? "min-h-screen" : ""}>
        {children}
      </main>
      {!isDashboard && <Footer data-component-id="src/app/LayoutContent.tsx:19:23" data-component-path="src/app/LayoutContent.tsx" data-component-line="19" data-component-end-line="19" data-component-file="LayoutContent.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />}
    </>
  );
}